import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { DeleteUserLeaveBoardRequest } from '../types';

export const deleteUserLeaveBoard = async ({
  pathParams: { boardId },
}: DeleteUserLeaveBoardRequest) => {
  const url = `/api/v2/auth/user/boards/${boardId}`;
  await apiAuthClient.delete(url);
};
